// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import sharedActions from '../../actions-list';

export const resetReportCriteria = () =>

    dispatch => {

        dispatch({
            type: actions.RESET_ADVANCED_CLAIM_SUMMARY_CRITERIA
        });

        dispatch({
            type: actions.RESET_ADVANCED_CLAIM_SUMMARY_REPORT
        });

        dispatch({
            hasNoResult: false,
            type: sharedActions.UPDATE_SHOW_NO_RESULTS_FOUND
        });

    };

export const updateClaimCreatedDates = dates => ({
    dates,
    type: actions.UPDATE_ADVANCED_CLAIM_SUMMARY_CLAIM_CREATED_DATE
});

export const updateCriterion = (property, value) => ({
    property,
    type: actions.UPDATE_ADVANCED_CLAIM_SUMMARY_CRITERION,
    value
});



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/action-creators/criteria.js